import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { FlagGroup as AkFlagGroup } from '@atlaskit/flag';
import { ButtonClickedEvent, withAnalytics } from '@atlassian/mpac-analytics';
import React, { Component } from 'react';
import { ANALYTICS_SUBJECT_ID_FLAG_ACTION } from '../../../analytics/Events';
import { isEmceeConnect } from '../../../utils/package-connect-utils';
import AtlaskitFlagWrapper from './AtlaskitFlagWrapper';
import ConnectFlagWrapper from './ConnectFlagWrapper';
class Flags extends Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "flagDismissed", flagId => {
      this.props.doRemoveFlag(flagId);
    });
    _defineProperty(this, "onAction", (action, flag) => {
      this.props.fireAnalyticsEvent({
        eventType: ButtonClickedEvent,
        actionSubjectId: ANALYTICS_SUBJECT_ID_FLAG_ACTION,
        attributes: {
          flagTitle: flag.title,
          flagType: flag.appearance,
          actionKey: action.key
        }
      });
      action.callback();
    });
  }
  shouldComponentUpdate(nextProps) {
    return !this.props.flags.equals(nextProps.flags);
  }
  render() {
    // Temporary workaround for previous atlaskit flags
    // not unmounting when replaced with other flags
    // https://ecosystem.atlassian.net/browse/AK-6218
    if (!this.props.flags.size) {
      return null;
    }
    return /*#__PURE__*/React.createElement("div", null, isEmceeConnect() ? this.props.flags.map(flag => /*#__PURE__*/React.createElement(ConnectFlagWrapper, {
      key: flag.key,
      flag: flag,
      onAction: this.onAction,
      onDismissed: this.flagDismissed
    })) :
    /*#__PURE__*/
    React.createElement(AkFlagGroup, {
      onDismissed: this.flagDismissed
    }, this.props.flags.map(flag => /*#__PURE__*/React.createElement(AtlaskitFlagWrapper, {
      key: flag.key,
      flag: flag,
      onAction: this.onAction,
      onDismissed: this.flagDismissed
    }))));
  }
}
export default withAnalytics(Flags);